import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import useEditionStageStore from '@/stores/editionStage'
import { type DreamDrawingImagePublicUrls, type Maybe } from '@/types'
import type { WDreamDrawingLikeCardProps } from '@wiosna-dev/wiosna-ui/types'
import vuexStore from '@/store'
// nowy task refactorowy NAP-X na przeniesienie child z vuex do pinii

const useChildStore = defineStore('child', () => {
  const isCurrentEdition = ref(false)

  function updateCurrentEdition(payload: boolean): void {
    isCurrentEdition.value = payload
  }

  const editionStage = useEditionStageStore()
  const isPaymentAllowedForChild = computed<boolean>(
    () => isCurrentEdition.value && editionStage.getPaymentAllowed
  )

  const isPrevRouteHomePage = ref(false)
  function updateIsPrevRouteHomePage(payload: boolean): void {
    isPrevRouteHomePage.value = payload
  }
  const dreamDrawingImagePublicUrls = computed<Maybe<DreamDrawingImagePublicUrls>>(
    () => vuexStore.getters['child/getChild']?.dream_drawing_image_public_urls
  )
  const dreamDrawingLikeCard = computed<WDreamDrawingLikeCardProps>(() => ({
    content: vuexStore.getters['child/getChild']?.dream_drawing_like_description ?? undefined,
    childName: vuexStore.getters['child/getChild']?.first_name ?? undefined
  }))
  return {
    isCurrentEdition,
    isPaymentAllowedForChild,
    updateCurrentEdition,
    isPrevRouteHomePage,
    updateIsPrevRouteHomePage,
    dreamDrawingImagePublicUrls,
    dreamDrawingLikeCard
  }
})

export default useChildStore
